/* Bambam Çocuk — product form (variant picker, gallery sync, sticky add-to-cart) */
(() => {
  'use strict';
  const S = window.BB?.strings || {};

  function formatMoney(cents, format = window.BB?.moneyFormat || '{{amount_with_comma_separator}} TL') {
    const value = Number(cents) / 100;
    const fmt = (n, dec, thou, decSep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        default: return fmt(value, 2, '.', ',');
      }
    });
  }
  window.BB = Object.assign(window.BB || {}, { formatMoney });

  function priceHTML(v) {
    if (v.compare_at_price > v.price) {
      return `<span class="visually-hidden">${S.salePrice || ''}</span><span class="price__sale">${formatMoney(v.price)}</span><s class="price__compare">${formatMoney(v.compare_at_price)}</s>`;
    }
    return `<span>${formatMoney(v.price)}</span>`;
  }

  function initForm(pform) {
    if (pform._init) return;
    pform._init = true;
    const variants = JSON.parse(pform.querySelector('[data-variants]')?.textContent || '[]');
    const root = pform.closest('[data-product-root]') || pform.parentElement;
    const idInput = pform.querySelector('[data-variant-id]');
    const atc = pform.querySelector('[data-atc]');
    const atcLabel = pform.querySelector('[data-atc-label]');
    const stock = pform.querySelector('[data-stock]');
    const fieldsets = Array.from(pform.querySelectorAll('[data-option-index]'));
    const updateUrl = pform.dataset.updateUrl === 'true';

    const selectedOptions = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value ?? null);

    function update() {
      const opts = selectedOptions();
      fieldsets.forEach((fs, i) => {
        const out = fs.querySelector('[data-option-value]');
        if (out) out.textContent = opts[i] ? `: ${opts[i]}` : '';
        // Mark values that are unavailable given the other selected options.
        fs.querySelectorAll('.pform__radio').forEach((radio) => {
          const label = fs.querySelector(`label[for="${radio.id}"]`);
          const ok = variants.some((v) => v.available && v.options[i] === radio.value && v.options.every((o, j) => j === i || !opts[j] || o === opts[j]));
          label?.classList.toggle('is-unavailable', !ok);
        });
      });

      // No option pickers (single / default-title variant): the only variant is the selection.
      const complete = opts.every((o) => o !== null);
      const variant = fieldsets.length === 0 ? variants[0] : (complete ? variants.find((v) => v.options.every((o, i) => o === opts[i])) : null);
      pform.classList.toggle('has-variant', Boolean(variant));
      if (!variant) { if (idInput) idInput.value = ''; return; }

      idInput.value = variant.available ? variant.id : '';
      if (atc) {
        atc.disabled = !variant.available;
        if (atcLabel) atcLabel.textContent = variant.available ? (S.addToCart || 'Sepete ekle') : (S.soldOut || 'Tükendi');
      }
      root.querySelectorAll('[data-price]').forEach((el) => { if (!el.closest('[data-bundle], .card, .related')) el.innerHTML = priceHTML(variant); });
      root.querySelectorAll('[data-sticky-price]').forEach((el) => { el.innerHTML = priceHTML(variant); });
      // "Sepette %X indirimle" line: the highest cart tier this single pair already reaches.
      root.querySelectorAll('[data-cart-deal]').forEach((el) => {
        const tier = JSON.parse(el.dataset.tiers || '[]').filter(([t, r]) => t > 0 && r > 0 && variant.price >= t).pop();
        el.hidden = !tier;
        if (!tier) return;
        const rate = el.querySelector('[data-deal-rate]');
        const price = el.querySelector('[data-deal-price]');
        if (rate) rate.textContent = `%${tier[1]}`;
        if (price) price.textContent = formatMoney(variant.price - Math.round(variant.price * tier[1] / 100));
      });

      if (stock) {
        if (variant.available && variant.qty !== null && variant.qty > 0 && variant.qty <= 3) {
          stock.hidden = false;
          stock.textContent = (S.lowStock || 'Son __COUNT__ çift').replace('__COUNT__', variant.qty);
        } else stock.hidden = true;
      }

      if (variant.media_id) {
        const slide = root.querySelector(`[data-media-id="${variant.media_id}"]`);
        const track = slide?.closest('[data-gallery-track]');
        if (slide && track && track.scrollWidth > track.clientWidth) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      if (updateUrl && fieldsets.length) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('bb:variant:change', { detail: { variant, root } }));
    }

    pform.addEventListener('change', (e) => { if (e.target.matches('.pform__radio')) update(); });

    // Clicking add-to-cart without a size: nudge the size row.
    atc?.addEventListener('click', (e) => {
      if (!idInput.value && fieldsets.length) {
        e.preventDefault();
        const missing = fieldsets.find((fs) => !fs.querySelector('input:checked'));
        (missing || fieldsets[0]).classList.remove('is-shake');
        void (missing || fieldsets[0]).offsetWidth;
        (missing || fieldsets[0]).classList.add('is-shake');
        (missing || fieldsets[0]).scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.BB?.toast?.(S.selectSize || 'Lütfen numara seçin');
      }
    });

    update();
  }

  function initGallery(root) {
    const track = root.querySelector('[data-gallery-track]');
    const dots = root.querySelectorAll('[data-gallery-dot]');
    if (!track || track._init) return;
    track._init = true;
    // Dots (mobile) and thumbnails (desktop) share data-gallery-dot; arrows and arrow keys step one slide.
    const slides = [...track.querySelectorAll('[data-index]')];
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const thumbs = root.querySelector('[data-gallery-thumbs]');
    const counter = root.querySelector('[data-gallery-current]');
    let current = 0;
    const go = (i) => {
      const slide = slides[Math.max(0, Math.min(slides.length - 1, i))];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const mark = (i) => {
      current = i;
      dots.forEach((d) => d.setAttribute('aria-current', Number(d.dataset.galleryDot) === i ? 'true' : 'false'));
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      if (counter) counter.textContent = i + 1;
      const thumb = thumbs?.querySelector(`[data-gallery-dot="${i}"]`);
      if (thumb && thumbs.scrollHeight > thumbs.clientHeight) {
        thumbs.scrollTo({ top: thumb.offsetTop - (thumbs.clientHeight - thumb.offsetHeight) / 2, behavior: 'smooth' });
      }
    };
    if ('IntersectionObserver' in window && slides.length > 1) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting && en.intersectionRatio > 0.6) mark(Number(en.target.dataset.index));
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach((s) => io.observe(s));
    }
    dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.galleryDot))));
    prev?.addEventListener('click', () => go(current - 1));
    next?.addEventListener('click', () => go(current + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        go(current + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
  }

  // Phones/tablets: the bar is up from the first screen (the size picker sits below the gallery), steps aside while the
  // size picker and buy buttons are on screen, and comes back once they scroll away (4 Nov; it used to wait until the
  // shopper had scrolled past the button). Without a size it takes them to the picker instead of adding.
  function initSticky(root) {
    const bar = document.querySelector('[data-sticky-atc]');
    const main = root.querySelector('[data-atc]');
    const btn = bar?.querySelector('[data-sticky-btn]');
    if (!bar || !main || bar._init || btn?.disabled) return;
    bar._init = true;
    const zone = root.querySelector('[data-pform]') || main;
    const narrow = window.matchMedia('(max-width: 989px)');
    const onScreen = new Map();
    const sync = () => {
      const show = narrow.matches && !onScreen.get(zone);
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
      document.body.classList.toggle('pdp-buy-visible', Boolean(onScreen.get(main)));
    };
    // The sticky header covers the top strip, so a button hidden under it counts as scrolled past.
    const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => onScreen.set(en.target, en.isIntersecting));
      sync();
    }, { rootMargin: `-${headerH}px 0px 0px 0px` });
    io.observe(zone);
    if (zone !== main) io.observe(main);
    narrow.addEventListener?.('change', sync);
    btn?.addEventListener('click', () => {
      const idInput = root.querySelector('[data-variant-id]');
      if (idInput?.value) main.click();
      else {
        const sizes = root.querySelector('.pform__option') || main;
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizes.classList.add('is-shake');
        setTimeout(() => sizes.classList.remove('is-shake'), 600);
        window.BB?.toast?.(S.selectSize || 'Lütfen numara seçin');
      }
    });
  }

  function initBundle(root) {
    const b = root.querySelector('[data-bundle]');
    if (!b || b._init) return;
    b._init = true;
    const items = [...b.querySelectorAll('[data-bundle-item]')];
    const foot = b.querySelector('[data-bundle-foot]');
    const btn = b.querySelector('[data-bundle-add]');
    const label = b.querySelector('[data-bundle-label]');
    const checked = () => items.filter((it) => it.querySelector('[data-bundle-check]')?.checked !== false);
    // Nothing is ticked up front; the add button shows only once the parent picks something.
    const update = () => {
      const n = checked().length;
      foot.hidden = n === 0;
      if (label) label.textContent = n > 1 ? btn.dataset.labelMany : btn.dataset.labelOne;
      items.forEach((it) => it.classList.toggle('is-on', !!it.querySelector('[data-bundle-check]')?.checked));
    };
    // Row one is the main product: it shows the size picked up top, or a link back to the size picker.
    const mainSize = b.querySelector('[data-bundle-main-size]');
    const toPicker = () => {
      const fs = root.querySelector('.pform__option');
      fs?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (fs) nudge(fs);
    };
    mainSize?.addEventListener('click', () => { if (!mainSize.classList.contains('is-set')) toPicker(); });
    // Single-size products have no picker to point at; a size already ticked (e.g. ?variant=) is shown right away.
    if (mainSize && !root.querySelector('[data-option-index]')) mainSize.hidden = true;
    const preset = root.querySelector('[data-option-index] input:checked')?.value;
    if (mainSize && preset) { mainSize.textContent = mainSize.dataset.tpl.replace('__SIZE__', preset); mainSize.classList.add('is-set'); }
    // Same size for each pick by default (siblings usually wear the main pick's size); a manual choice is kept.
    const matchSize = (variant) => {
      if (!variant) return;
      const size = String(variant.option1 || variant.title || '').trim();
      items.forEach((it) => {
        const sel = it.querySelector('[data-bundle-variant]');
        if (!sel || sel.tagName !== 'SELECT' || sel._manual) return;
        const opt = [...sel.options].find((o) => o.value && !o.disabled && o.textContent.trim().split(/[\s-]/).includes(size));
        if (opt) sel.value = opt.value;
      });
    };
    items.forEach((it) => {
      it.querySelector('[data-bundle-variant]')?.addEventListener('change', (e) => {
        e.target._manual = true;
        // Choosing a size for a pick means they want it
        const box = it.querySelector('[data-bundle-check]');
        if (box && e.target.value) { box.checked = true; update(); }
      });
      it.querySelector('[data-bundle-check]')?.addEventListener('change', () => update());
      // The whole row toggles the pick (the size select keeps its own behaviour)
      it.addEventListener('click', (e) => {
        if (e.target.closest('select, input, label, button')) return;
        const box = it.querySelector('[data-bundle-check]');
        if (box) { box.checked = !box.checked; update(); }
      });
    });
    document.addEventListener('bb:variant:change', (e) => {
      if (e.detail.root !== root) return;
      matchSize(e.detail.variant);
      if (mainSize && e.detail.variant) {
        const size = String(e.detail.variant.option1 || e.detail.variant.title || '').trim();
        mainSize.textContent = mainSize.dataset.tpl.replace('__SIZE__', size);
        mainSize.classList.add('is-set');
      }
    });
    function nudge(el) { el.classList.remove('is-shake'); void el.offsetWidth; el.classList.add('is-shake'); setTimeout(() => el.classList.remove('is-shake'), 600); }
    btn.addEventListener('click', (e) => {
      const mainId = root.querySelector('[data-variant-id]')?.value;
      if (!mainId) {
        toPicker();
        window.BB?.toast?.(S.selectSize || 'Lütfen numara seçin');
        return;
      }
      const lines = [{ id: Number(mainId), quantity: 1 }];
      for (const it of checked()) {
        const sel = it.querySelector('[data-bundle-variant]');
        if (!sel?.value) { sel?.focus(); if (sel) nudge(sel); window.BB?.toast?.(S.selectSize || 'Lütfen numara seçin'); return; }
        lines.push({ id: Number(sel.value), quantity: 1 });
      }
      window.BB.addItems(lines, root.querySelector('.js-fly-source'), e.currentTarget);
    });
    update();
  }

  function initInstallments(root) {
    const box = root.querySelector('[data-installments]');
    if (!box || box._init) return;
    box._init = true;
    root.querySelector('[data-open-installments]')?.addEventListener('click', () => {
      box.open = true;
      // The info column is sticky, so scrollIntoView is a no-op there: scroll the window instead.
      const header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 80;
      window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - header - 24, behavior: 'smooth' });
    });
    // Same formula as the Liquid table (PayTR's): total = price / (1 - rate/100), monthly = total / n.
    document.addEventListener('bb:variant:change', (e) => {
      if (e.detail.root !== root || !e.detail.variant) return;
      const price = Number(e.detail.variant.price);
      box.querySelectorAll('tr[data-n]').forEach((tr) => {
        const total = Math.round(price / (1 - Number(tr.dataset.rate) / 100));
        tr.querySelector('[data-t]').textContent = formatMoney(total);
        tr.querySelector('[data-m]').textContent = formatMoney(Math.round(total / Number(tr.dataset.n)));
      });
    });
  }

  function init(ctx = document) {
    ctx.querySelectorAll('[data-pform]').forEach(initForm);
    ctx.querySelectorAll('[data-product-root]').forEach((root) => { initGallery(root); initSticky(root); initBundle(root); initInstallments(root); });
    if (ctx.matches?.('[data-product-root]')) { initGallery(ctx); }
  }

  init();
  document.addEventListener('bb:product:loaded', (e) => init(e.detail.root));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
